$(document).on('change', '#address-country-state-selector select[name$="country_id"]', function () {
    let wrapper = $(document).find('#address-country-state-selector');
    let value = $(this).val() ?? '';
    let stateInput = wrapper.find('select[name="state_id"]').first();

    if (value.length < 1) {
        stateInput.attr('disabled', true).val('');
        return;
    }

    $.get(wrapper.data('states-route').replace(/\d+$/gi, value), null, (result) => {
        let stateInput = wrapper.find('select[name$="state_id"]').first();
        stateInput.html(result);
        stateInput.attr('disabled', stateInput.find('option').length < 2);
    })
});
